import { AUDIT_LOGS_TAB } from 'common/constants/user';

export const COMPANIES_SLUG = 'companies';
export const REPORTS_SLUG = 'reports';
export const DASHBOARD_SLUG = 'dashboard';
export const OVERVIEW_SLUG = 'overview';
export const PREVIOUS_REPORTS_SLUG = 'previous-reports';
export const SETTINGS_SLUG = 'settings';
export const SUBSCRIPTION_SLUG = 'subscription';
export const INFORMATION_SLUG = 'information';
export const OPERATIONS_SLUG = 'operations';

export const COMPANY_DETAILS_SLUGS = [SUBSCRIPTION_SLUG];

export const WORKBOARD_SLUG = 'workboard';
export const CURRENT_VALUATIONS_SLUG = 'current-valuations';
export const PAST_VALUATIONS_SLUG = 'past-valuations';
export const OPPORTUNITIES_SLUG = 'opportunities';
export const MODELS_SLUG = 'models';
export const ACCOUNT_SETTINGS_SLUG = 'account-settings';
export const ASSIGNMENT_RULES_SLUG = 'assignment-rules';

// Analyst tab titles
export const CURRENT_VALUATIONS_TITLE = 'Current Valuations';
export const PAST_VALUATIONS_TITLE = 'Past Valuations';
export const OPPORTUNITIES_TITLE = 'Opportunities';
export const MODELS_TITLE = 'Models';
export const ACCOUNT_SETTINGS_TITLE = 'Account Settings';
export const AUDIT_LOGS_TITLE = 'Audit Logs';
export const ASSIGNMENT_RULES_TITLE = 'Assignment Rules';

// Analyst tab mapping dictionary
export const WORKBOARD_TAB_TITLES: Record<string, string> = {
  [CURRENT_VALUATIONS_SLUG]: CURRENT_VALUATIONS_TITLE,
  [PAST_VALUATIONS_SLUG]: PAST_VALUATIONS_TITLE,
  [OPPORTUNITIES_SLUG]: OPPORTUNITIES_TITLE,
  [MODELS_SLUG]: MODELS_TITLE,
  [ACCOUNT_SETTINGS_SLUG]: ACCOUNT_SETTINGS_TITLE,
  [AUDIT_LOGS_TAB]: AUDIT_LOGS_TITLE,
  [ASSIGNMENT_RULES_SLUG]: ASSIGNMENT_RULES_TITLE,
};
